import { z } from 'zod';

export const UserAccessType = z.enum([
  'VISITOR',
  'FREE',
  'LEAD',
  'PARTNER',
  'TALENT',
  'EXPERT_FREE',
  'STARTER',
  'EXPERT',
]);

export type UserAccessTypeT = z.infer<typeof UserAccessType>;
